import { toast } from 'sonner';

import { getIsInReceiveSession } from '@utils/helpers';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

type ApiError = {
  data?: { userMessage?: string | null };
  axiosErrorResponse?: unknown;
};

export const showApiErrorToast = (error: unknown) => {
  const apiError = error as ApiError | null | undefined;
  if (apiError && 'axiosErrorResponse' in apiError) return;

  toast.error(apiError?.data?.userMessage || DEFAULT_ERROR_MESSAGE, {
    duration: 3000,
    className: getIsInReceiveSession() ? 'dark' : '',
  });
};
